// @ts-nocheck
import styled from "styled-components";

const openedStyle = {
    maxWidth: '80%',
    transition: 'max-width 0.5s',
    '-webkit-transition': 'max-width 0.5s',
};
const closedStyle = {
    maxWidth: '5%',
    transition: 'max-width 0.5s',
    '-webkit-transition': 'max-width 0.5s',
};


const openedMobileStyle = {
    maxHeight: '80%',
    transition: 'all 0.5s ease-out',
    '-webkit-transform': 'max-height 0.5s',
};
const closedMobileStyle = {
    maxHeight: '5%',
    transition: 'all 0.5s ease-out',
    '-webkit-transform': 'max-height 0.5s',
};


interface OuterWrapperProps {
    isTabSelected:boolean,
    backgroundImage: string
}

const OuterWrapper = styled.div`
    overflow-x: auto;

    @media (min-width: 481px) {
        height: 100vh;
        max-height: 100vh;
        display: flex;
        flex: 1;
        ${(props: OuterWrapperProps) => props.isTabSelected ? openedStyle : closedStyle }
        background-image: url(${(props: OuterWrapperProps) => props.backgroundImage});
        background-repeat: repeat;
        background-size: contain;
    }

    @media (max-width: 480px) {
        width: 100vw;
        max-width: 100vw;
        display: flex;
        flex: 1;
        ${(props: OuterWrapperProps) => props.isTabSelected ? openedMobileStyle : closedMobileStyle }
        background-image: url(${(props: OuterWrapperProps) => props.backgroundImage});
        background-repeat: repeat;
        background-size: contain;
    }
`;

interface InnerWrapperProps {
    backgroundImage: string
}
const InnerWrapper = styled.div`
    @media (min-width: 481px) {
        border-top-right-radius: 60px;
        height: 100vh;
        max-height: 100vh;
        display: flex;
        flex: 1;
        background-image: url(${(props: InnerWrapperProps) => props.backgroundImage});
        background-repeat: repeat;
    }

    @media (max-width: 480px) {
        border-bottom-right-radius: 60px;
        border-bottom-left-radius: 60px;
        width: 100vw;
        max-width: 100vw;
        display: flex;
        flex: 1;
        background-image: url(${(props: InnerWrapperProps) => props.backgroundImage});
        background-repeat: repeat;
    }
`;

export {
    OuterWrapper,
    InnerWrapper,
};
